import { render, staticRenderFns } from "./NotificationTypeManagelist.vue?vue&type=template&id=3aeee6ec&scoped=true&"
import script from "./NotificationTypeManagelist.vue?vue&type=script&lang=js&"
export * from "./NotificationTypeManagelist.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTypeManagelist.vue?vue&type=style&index=0&id=3aeee6ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeee6ec",
  null
  
)

export default component.exports